import { useParams } from "react-router-dom";
import DeepLinkableDialog from "../../api/models/test-request/DeepLinkableDialog";
import RequestsPagePathParams from "../../api/models/test-request/RequestsPagePathParams";

export enum TestRequestTabType {
  DESCRIPTION = 0,
  SUBSTRATE = 1,
  PRODUCT = 2,
  TEST = 3,
  REPORT = 4,
  HISTORY = 5,
  APROE_PROJECT = 6,
}

export default function useTestRequestParams(): {
  testRequestId: string;
  tab: TestRequestTabType;
  dialog?: DeepLinkableDialog;
} {
  const { testRequestId, tabName, dialog } = useParams<RequestsPagePathParams>();
  const tabNumber = Math.min(parseInt(tabName, 10) || 0, 5);
  const tab =
    Object.keys(TestRequestTabType)
      .map((type) => type as keyof typeof TestRequestTabType)
      .filter((type) => TestRequestTabType[type] === tabNumber)
      .map((type) => TestRequestTabType[type])
      .pop() || TestRequestTabType.DESCRIPTION;
  return { testRequestId, tab, dialog };
}
